/* Shared night palette, including public pages and the floating timer window. */
:root {
  color-scheme: dark;
  --bg: #0b0b0d;
  --surface: #141416;
  --soft: #1b1b1e;
  --soft2: #242428;
  --line: #2d2d33;
  --muted: #a3a3ae;
  --text: #e9e9ee;
  --forest: #0d0d0f;
  --forest-light: #19191c;
  --sage: #c8c8d0;
  --accent: #dedee5;
  --focus-ring: #c8c8d0;
  --night-ink: #101012;
  --night-secondary: #c4c4ce;
  --night-faint: #91919e;
  --night-border-strong: #62626c;
  --night-inset: #101012;
  --night-hover: #202024;
  --night-emphasis: #dedee5;
  --night-danger: #f29b9b;
  --night-success: #97c6aa;
  --night-warning: #d9bd87;
  --theme-rgb: 233 233 238;
  --theme-surface-rgb: 20 20 22;
  --theme-shell-rgb: 13 13 15;
  --theme-shell-surface: #101012;
  --theme-action-hover: #f0f0f4;
  --theme-selection: #45454f;
}

html {
  background: var(--bg);
  scrollbar-color: var(--night-border-strong) var(--bg);
}

::selection {
  background: var(--theme-selection);
  color: var(--text);
}

input,
textarea,
select,
button {
  accent-color: var(--night-emphasis);
}

input::placeholder,
textarea::placeholder {
  color: var(--night-faint);
  opacity: 1;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus {
  -webkit-text-fill-color: var(--text);
  box-shadow: 0 0 0 1000px var(--soft) inset;
  caret-color: var(--text);
}

option {
  background: var(--surface);
  color: var(--text);
}

/* Final shared interaction treatments. */
body[data-presentation="workspace"] .topbar {
  background: rgb(var(--theme-shell-rgb) / 0.96);
}
body[data-presentation="workspace"] .sidebar {
  background: var(--theme-shell-surface);
}
body[data-presentation="workspace"] .btn.black:hover {
  background: var(--theme-action-hover);
  border-color: var(--theme-action-hover);
  color: var(--night-ink);
}
.sidebar .nav button.active {
  background: var(--soft2);
  box-shadow: inset 3px 0 0 var(--night-emphasis);
}
.sidebar .nav button.active .ui-icon {
  color: var(--text);
}
.planning-tabs button[aria-pressed="true"],
.focus-task-tabs button[aria-selected="true"] {
  background: var(--soft2);
  color: var(--text);
}
.date-picker-grid .outside-month {
  color: var(--night-faint);
}
.switch.on i {
  background: var(--night-ink);
}
.theme-preview i {
  border: 1px solid var(--night-border-strong);
}

.modal-backdrop {
  background: rgb(0 0 0 / 0.72);
  backdrop-filter: blur(6px);
}
